import React, {FC} from 'react'
import { Segment } from 'semantic-ui-react'
import { withRouter } from 'react-router-dom'
import { number as numberFormatter, date as dateFormatter } from 'loankeeper-common/helpers/formatters'
import dateComparer from 'loankeeper-common/helpers/dateComparer'
import { ifThenElse } from 'loankeeper-common/helpers'
//@ts-ignore
import withConstantPermissions from 'shared/containers/withConstantPermissions'
//@ts-ignore
import { SegmentGroup, FlexTableChild, TableContainer } from 'shared/StyledComponents'
import { colors } from 'shared'
//@ts-ignore
import LKGrid from 'shared/LKGrid'
import { constants as DCConstants } from '../../DetailsContainer'

import { translateCmd, translateBase, icon } from '../helpers'
import { formName } from '../constants'
import { MemoizedGridProps, CollateralProps } from '../types'
const config = (pushDetailsRoute) => ({
  gridIdentity: {
    formName,
    objectName: 'dbgrd_collaterals',
  },

  columnConfigs: {
    RegDate: {
      comparator: dateComparer,
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    MarketPrice: {
      valueFormatter: ({ value }) => numberFormatter(value),
      cellStyle: { textAlign: 'right' },
    },
    MarketPriceCurr: {},
    Expired: {
      iconComponent: (value: number) => (value !== 0 ? 'clock' : null),
    },
    IsInsured: {
      iconComponent: (value: number) => (value !== 0 ? 'life_ring' : null),
    },
    IsAttached: {
      iconComponent: (value: number) => (value !== 0 ? 'attach' : null),
    },
  },

  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableRowSelection: true,
  syncGridState: true,

  getRowStyle: ({
    node: {
      data: { StateID },
    },
    //@ts-ignore
  }) => ifThenElse(StateID === 6, { backgroundColor: colors.grey }, {}),

  getContextMenuItems: (params) => {
    const {
      node: { data },
    } = params

    return [
      {
        name: translateCmd('view_collateral'),
        action: () => pushDetailsRoute(data),
        icon: 'info',
        permissionKey: 'VIEW_COLLATERAL',
      },
    ]
  },
})

const MemoizedLKGrid:FC<MemoizedGridProps> = React.memo(({ ID, rowData, onRowDoubleClicked, pushDetailsRoute }) => (
  <LKGrid
    rowData={rowData}
    onRowDoubleClicked={onRowDoubleClicked}
    {...config(pushDetailsRoute)}
    instanceName={`${DCConstants.DetailsGridPrefixes.client}-${ID}-Collaterals`}
  />
))

@withRouter
@withConstantPermissions()
class Collaterals extends React.Component<CollateralProps> {
  pushDetailsRoute = ({ ID, HashSum_CollateralID_, TypeID }) => {
    this.props.history.push(`/secure/collateral/${ID}/details/${HashSum_CollateralID_}/${TypeID}`)
  }

  onRowDoubleClicked = ({ node: { data } }) => {
    if (this.props.permissions.VIEW_COLLATERAL) {
      this.pushDetailsRoute(data)
    }
  }

  render() {
    const { data, ID } = this.props
    return (
      <SegmentGroup>
        <Segment.Group>
          <FlexTableChild>
            <TableContainer>
              <MemoizedLKGrid
                ID={ID}
                rowData={data}
                onRowDoubleClicked={this.onRowDoubleClicked}
                pushDetailsRoute={this.pushDetailsRoute}
              />
            </TableContainer>
          </FlexTableChild>
        </Segment.Group>
      </SegmentGroup>
    )
  }
}

//@ts-ignore
Collaterals.config = {
  title: () => translateBase('tb_collaterals'),
  name: 'collaterals',
  component: Collaterals,
  api: 'collaterals',
  icon: icon('tb_collaterals'),
}
//@ts-ignore
Collaterals.defaultProps = {
  data: [],
}

export default Collaterals
